//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { CommonHelper } from "../../helpers/common-helper"
import { DataProvider } from "../../helpers/data-provider"
import { LocalizationHelper } from "../../helpers/localization-helper"

import { Enums } from "../../models/common/enums"
import { OpLocation } from "../../models/core/op-location"
import { SESSION } from "../../models/custom/session"

export class DepositoryHelper {

    // Consts

    public static get FILE_NAME_PREFIX(): string { return 'depositories' }
    public static get REFERENCE_TYPE(): Enums.ReferenceType { return Enums.ReferenceType.IdLocation }
    public static get SIMAX_MODULE_NAME(): Enums.SimaxModuleName { return Enums.SimaxModuleName.Depository }

    // Consts End


    // Methods

    public static deleteDepository(dataProvider: DataProvider, idLocation: number): JQueryPromise<void> {
        const deferred: JQueryDeferred<void> = $.Deferred<void>()
        const toDelete: OpLocation = new OpLocation(null)

        toDelete.idLocation = idLocation

        dataProvider.Location
            .deleteLocation(toDelete)
            .then(() => {
                CommonHelper.openInfoPopup(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETED, DepositoryHelper.SIMAX_MODULE_NAME))
                deferred.resolve()
            })
            .fail((error: any) => {
                let errorMsg: string = error

                if (SESSION.isType(error)) {
                    errorMsg = (<SESSION>error).toString()
                    CommonHelper.openInfoPopup(errorMsg, 'error', 4000)
                } else {
                    CommonHelper.openInfoPopup(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETE_ERROR, DepositoryHelper.SIMAX_MODULE_NAME), 'error', 4000)
                }

                deferred.reject(errorMsg)
            })

        return deferred.promise()
    }

    public static saveDepository(dataProvider: DataProvider, depository: OpLocation): JQueryPromise<OpLocation> {
        const deferred: JQueryDeferred<OpLocation> = $.Deferred<OpLocation>()

        dataProvider.Depository
            .saveDepository(depository)
            .then((savedObject: OpLocation) => {
                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                let errorMsg: string = error

                if (SESSION.isType(error)) {
                    errorMsg = (<SESSION>error).toString()
                }

                deferred.reject(errorMsg)
            })

        return deferred.promise()
    }

    // Methods End
}